import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';

import { showLoading, hideLoading } from '../../../store/app';
import { toastr } from '../../CustomToast';
import BaseDialog from '../BaseDialog';
import SelectEnergyTracerRole from '../../Selectors/energytracer/SelectEnergyTracerRole';
import SelectEnergyTracerOrganization from '../../Selectors/energytracer/SelectEnergyTracerOrganization';
import SelectEnergyTracerUser from '../../Selectors/energytracer/SelectEnergyTracerUser';
import WebAPIClient from '../../../api/_energytracer';

export const defaultState = {
  portfolio_id: '',
  user_id: '',
  email: '',
  role: 'user',
};

function PortfolioUserDialog(props) {
  const { users, portfolios, setTableRows, open, setOpen } = props;
  const dispatch = useDispatch();

  const [membership, setMembership] = useState(defaultState);

  const handleSelectUser = (user) => {
    setMembership((prevMembership) => ({
      ...prevMembership,
      user_id: user?.user_id || '',
      email: user?.email || '',
      name: user?.name || '',
      first_name: user?.first_name || '',
      last_name: user?.last_name || '',
    }));
  };

  const handleClose = () => {
    setOpen(false);
    setMembership({ ...defaultState });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(showLoading());
    try {
      const response = await new WebAPIClient().POST(
        `portfolios/${membership.portfolio_id}/users`,
        { ...membership }
      );
      setTableRows((prev) => [
        {
          ...membership,
          user_id: response.id,
          portfolio_name: portfolios.find(
            (portfolio) => portfolio.id === membership.portfolio_id
          ).name,
        },
        ...prev,
      ]);
      dispatch(hideLoading());
      toastr.success({ title: 'Membership Updated' });
    } catch (err) {
      dispatch(hideLoading());
      toastr.error({ title: 'Request Failed' });
    }
    handleClose();
  };

  const id = open ? 'create-membership-dialog' : '';
  return (
    <BaseDialog
      id={id}
      title='Create Membership'
      submitText='Create'
      disabled={false}
      handleClose={handleClose}
      handleSubmit={handleSubmit}>
      <form onSubmit={handleSubmit}>
        <List disablePadding>
          <ListItem disableGutters>
            <SelectEnergyTracerOrganization
              label='Portfolio'
              portfolios={portfolios}
              orgId={membership.portfolio_id}
              setOrgId={(portfolioId) =>
                setMembership((prev) => {
                  return { ...prev, portfolio_id: portfolioId };
                })
              }
            />
          </ListItem>
          <ListItem disableGutters>
            <SelectEnergyTracerUser
              users={users}
              userId={membership.user_id}
              setUser={handleSelectUser}
            />
          </ListItem>
          <ListItem disableGutters>
            <SelectEnergyTracerRole
              appId={'energytracer'}
              role={membership.role}
              setRole={(role) =>
                setMembership((prev) => {
                  return { ...prev, role: role };
                })
              }
            />
          </ListItem>
        </List>
      </form>
    </BaseDialog>
  );
}

export default PortfolioUserDialog;
